import React from 'react';
import { FormState } from 'react-hook-form';
import { CustomSurveyFormData } from '../utils';

interface UseCustomSurveyValidationProps {
	formState: FormState<CustomSurveyFormData>;
	setShowEditSurveyName: (show: boolean) => void;
}

// Hook for validation error handling
export const useCustomSurveyValidation = ({ formState, setShowEditSurveyName }: UseCustomSurveyValidationProps) => {
	React.useEffect(() => {
		if (formState.errors?.name?.message) {
			setShowEditSurveyName(true);
		}
	}, [formState.errors, setShowEditSurveyName]);
};
